/**
 * Auth storage helpers for Pioneer Marketplace.
 *
 * All localStorage access for auth/session data MUST go through this module.
 * This satisfies the architecture rule: no raw localStorage in UI code.
 */

export function getToken(): string | null {
  return localStorage.getItem('token');
}

export function setToken(token: string): void {
  localStorage.setItem('token', token);
}

export function removeToken(): void {
  localStorage.removeItem('token');
}

export function getSelectedOrg(): string | null {
  return localStorage.getItem('selectedOrg') || localStorage.getItem('orgId');
}

export function setSelectedOrg(orgId: string): void {
  localStorage.setItem('selectedOrg', orgId);
  localStorage.setItem('orgId', orgId);
}

export function getUser(): string | null {
  return localStorage.getItem('user');
}

export function setUser(userJson: string): void {
  localStorage.setItem('user', userJson);
}

/**
 * Clear all auth-related storage (logout).
 */
export function clearAuth(): void {
  localStorage.removeItem('token');
  localStorage.removeItem('selectedOrg');
  localStorage.removeItem('orgId');
  localStorage.removeItem('user');
}
